/*
 * telemedicine-session (schema)
 */
import { boolean, integer, text, timestamp, uuid, varchar } from "drizzle-orm/pg-core"
import { schema } from "../constants"
import { patients } from "../patient/patient.schema"
import { practitioners } from "../practitioner/practitioner.schema"
import { appointments } from "../appointment/appointment.schema"
import { users } from "../user/user.schema"

export const SESSION_STATUSES = [
	"waiting_patient",    // practitioner started, patient not yet in waiting room
	"waiting_admission",  // patient in waiting room, practitioner has not yet admitted
	"active",             // both admitted and connected
	"ended",              // session completed normally
	"failed",             // connection failure
] as const

export const telemedicineSessions = schema.table("telemedicine_sessions", {
	id: uuid("id").primaryKey().notNull().defaultRandom(),

	// --- Relations ---
	patientId: uuid("patient_id").notNull().references(() => patients.id, { onDelete: "cascade" }),
	practitionerId: uuid("practitioner_id").references(() => practitioners.id, { onDelete: "set null" }),
	appointmentId: uuid("appointment_id").references(() => appointments.id, { onDelete: "set null" }),

	// --- Status ---
	status: varchar("status", { length: 32 }).notNull().default("waiting_patient"),

	// --- Chime Meeting ---
	chimeMeetingId: varchar("chime_meeting_id", { length: 256 }),
	chimeMeetingData: text("chime_meeting_data"),          // JSON: full Chime Meeting object

	// --- Attendees ---
	practitionerAttendeeId: varchar("practitioner_attendee_id", { length: 256 }),
	practitionerAttendeeData: text("practitioner_attendee_data"), // JSON: Attendee + JoinToken
	patientAttendeeId: varchar("patient_attendee_id", { length: 256 }),
	patientAttendeeData: text("patient_attendee_data"),           // JSON: populated on admit

	// --- Timing ---
	startedAt: timestamp("started_at", { withTimezone: true }),
	endedAt: timestamp("ended_at", { withTimezone: true }),
	durationSeconds: integer("duration_seconds"),

	// --- Diagnostics ---
	connectionLog: text("connection_log"), // JSON array of { ts, event, detail }

	// --- System ---
	active: boolean("active").notNull().default(true),
	createdAt: timestamp("created_at", { withTimezone: true }).notNull().defaultNow(),
	updatedAt: timestamp("updated_at", { withTimezone: true }).notNull().defaultNow(),
	createdBy: uuid("created_by").references(() => users.id, { onDelete: "set null" }),
	updatedBy: uuid("updated_by").references(() => users.id, { onDelete: "set null" }),
})
